import { INFINITY_TABLE } from "@/config";

export function getColumnHeaderHeight(expandedWindow: boolean): number {
	return expandedWindow
		? INFINITY_TABLE.COLUMN_HEADER_HEIGHT
		: INFINITY_TABLE.COLUMN_HEADER_COLLAPSED;
}
